import { render, staticRenderFns } from "./ResourceRoute.vue?vue&type=template&id=2ee04008&scoped=true"
import script from "./ResourceRoute.vue?vue&type=script&lang=js"
export * from "./ResourceRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee04008",
  null
  
)

export default component.exports